import React from "react";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { performHttpRequest } from "../../../../axios/PerformHttpRequest";
import Input from "../../../core/Inputs/DefaultInput";
import style from "../../style.module.css";
import Modal from "react-bootstrap/Modal";
import Select from "react-select/creatable";
import Svg from "../../../component/Svg";
import { getTokenData } from "../../../store/actions/authAction";

export const DuplicateRoi = ({ onClose, rowData }) => {
  const apiUrl = process.env.REACT_APP_NODE_API_URL;

  const [roiLanguageDuplicate, setRoiLanguageDuplicate] = useState([]);
  const [roiCurrencyDuplicate, setRoiCurrencyDuplicate] = useState([]);
  const [roiCountryDuplicate, setRoiCountryDuplicate] = useState([]);
  const [duplicateProjectName, setDuplicateProjectName] = useState("");
  const [duplicateCountry, setDuplicateCountry] = useState(null);
  const [duplicatePrimaryCurrency, setDuplicatePrimaryCurrency] = useState(null);
  const [duplicateDefaultLanguage, setDuplicateDefaultLanguage] = useState(null);
  const [userId, setuserId] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTokenData(setuserId));
  }, [userId, dispatch]);
  useEffect(() => {
    getLanguageCurrencyAndTemplateDetail();
  }, []);

  const getLanguageCurrencyAndTemplateDetail = async () => {
    try {
      const response = await performHttpRequest(
        "GET",
        `${apiUrl}/roi/roiLanguage&Currency`,
        ""
      );

      setRoiLanguageDuplicate(response?.data?.languageResult);
      setRoiCurrencyDuplicate(response?.data?.currencyResult);
      setRoiCountryDuplicate(response?.data?.countryResult || []);
    } catch (error) {
      console.error("Error", error);
      toast.error(error?.response?.data?.responseText);
    }
  };

  const parseFirstArrayValue = (value) => {
    if (!value) return null;
    try {
      const parsed = typeof value === "string" ? JSON.parse(value) : value;
      if (Array.isArray(parsed) && parsed.length > 0) {
        return String(parsed[0]).replace(/"/g, "");
      }
    } catch (error) {
      return null;
    }
    return null;
  };

  useEffect(() => {
    if (!rowData) return;

    const defaultCountry = parseFirstArrayValue(rowData.countries);
    const defaultCurrency = parseFirstArrayValue(rowData.primary_currency);

    if (defaultCountry) setDuplicateCountry(defaultCountry);
    if (defaultCurrency) setDuplicatePrimaryCurrency(defaultCurrency);
    if (rowData.defaultlanguage) {
      setDuplicateDefaultLanguage(rowData.defaultlanguage);
    }
  }, [rowData]);

  const getDefaultArrayValue = (selectedValue, fallbackValue) => {
    if (selectedValue) return [selectedValue];
    const fallback = parseFirstArrayValue(fallbackValue);
    return fallback ? [fallback] : [];
  };

  const handleDuplicateCountryChange = (selectedOption) => {
    setDuplicateCountry(selectedOption?.value || null);
  };

  const handleDuplicatePrimaryCurrencyChange = (selectedOption) => {
    setDuplicatePrimaryCurrency(selectedOption?.value || null);
  };

  const hanldleDuplicateDefaultLanguageChange = (selectedOption) => {
    setDuplicateDefaultLanguage(selectedOption?.value || null);
  };

  const handleClose = () => {
    onClose(); // Calling the onClose function passed from the parent component
  };

  const handleRoiSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await performHttpRequest(
        "POST",
        `${apiUrl}/roi//duplicateRoi`,
        {
          added_by: userId,
          roi_id: rowData?.id,
          roi_name: duplicateProjectName || rowData?.name,
          primary_currency: getDefaultArrayValue(
            duplicatePrimaryCurrency,
            rowData?.primary_currency
          ),
          additional_currency: [],
          default_language:
            duplicateDefaultLanguage || rowData?.defaultlanguage || "",
          country_name: getDefaultArrayValue(
            duplicateCountry,
            rowData?.countries
          ),
        }
      );

      if (response?.data?.statusCode === 200) {
        toast.success("Roi Duplicated Successfully", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        onClose(true);
      } else {
        toast.error("Roi Duplication failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.responseText);
    }
  };

  return (
    <>
      <div className="fade modal-backdrop show"></div>
      <div className="modal fade show d-block modal-duplicate-roi">
        <Modal.Dialog>
          <Modal.Header closeButton onClick={handleClose}>
            <div className="d-flex flex-wrap">
              <h5>Duplicate project</h5>
              <p>
                {" "}
                Provide a few details to configure the settings of your
                calculator{" "}
              </p>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group mb-3">
              <label className="form-label-custom">
                Please enter the name of the project
              </label>
              <Input
                type="text"
                view="outlined"
                color="default"
                label=""
                placeholder="Your project name"
                value={rowData?.name}
                clearButton
                fill
                className={"formsinput" + " " + style.card__exp}
                onChange={(e) => setDuplicateProjectName(e.target.value)}
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label-custom">
                {" "}
                For which countries is this calculator applicable?*{" "}
              </label>
              <Select
                classNamePrefix="select"
                isClearable
                isSearchable
                options={roiCountryDuplicate.map((country) => ({
                  value: country.country_name,
                  label: country.country_name,
                }))}
                onChange={handleDuplicateCountryChange}
                value={
                  duplicateCountry
                    ? {
                        value: duplicateCountry,
                        label: duplicateCountry,
                      }
                    : null
                }
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label-custom">
                {" "}
                What is the primary currency for your calculator?{" "}
              </label>
              <Select
                classNamePrefix="select"
                isClearable
                isSearchable
                onChange={handleDuplicatePrimaryCurrencyChange}
                options={roiCurrencyDuplicate.map((currency) => ({
                  value: currency.currency_name,
                  label: currency.currency_name,
                }))}
                value={
                  duplicatePrimaryCurrency
                    ? {
                        value: duplicatePrimaryCurrency,
                        label: duplicatePrimaryCurrency,
                      }
                    : null
                }
              />
            </div>

            <div className="form-group mb-3">
              <label className="form-label-custom">
                Select the default language for your calculator
              </label>
              {/* <Input
                type="text"
                view="outlined"
                color="default"
                label=""
                placeholder="Company name"
                value={rowData?.defaultlanguage}
                clearButton
                fill
                className={"formsinput" + " " + style.card__exp}
              /> */}

              <Select
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={document.body}
                className="custom-select"
                classNamePrefix="select"
                isClearable
                onChange={hanldleDuplicateDefaultLanguageChange}
                options={roiLanguageDuplicate.map((language) => ({
                  value: language.language_name,
                  label: language.language_name,
                }))}
                value={
                  duplicateDefaultLanguage
                    ? {
                        value: duplicateDefaultLanguage,
                        label: duplicateDefaultLanguage,
                      }
                    : null
                }
              />
            </div>

            <div className="button-wrap d-flex flex-wrap justify-content-center gap-3">
              {/* <button className="btn btn-bordered color-cancel">
                        {" "}
                        Back{" "}
                      </button> */}
              <button
                className="d-inline-flex align-items-center btn roi-btn-primary"
                onClick={handleRoiSubmit}
              >
                {" "}
                <span className="with-icon">Duplicate project</span>{" "}
                <div className="icon">
                  <Svg name="roi-button-arrow" />
                </div>{" "}
              </button>
            </div>
          </Modal.Body>
        </Modal.Dialog>
      </div>
    </>
  );
};

export default DuplicateRoi;
